import axios from '../../http'

class DBSiteSet {
  // 获取系统设置
  getDBSiteSystemSetting() {
    const url = `/api/mall/setting/get`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 修改系统设置
  updateDBSiteSystemSetting(data) {
    const url = `/api/mall/setting/modify`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 获取业务流程设置
  getDBBusinessSetting() {
    const url = `/api/bus/setting/get`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 更新业务流程设置
  updateDBBusinessSetting(data) {
    const url = `/api/bus/setting/modify`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 获取线下支付所有银行卡账号
  getDBSiteOfflineBankAccountList() {
    const url = `/api/back/pay/underline/get/all`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 新增线下支付银行卡账号
  addDBSiteOfflineBankAccount(data) {
    const url = `/api/back/pay/underline/add`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 更新线下支付银行卡账号信息
  updateDBSiteOfflineBankAccount(data) {
    const url = `/api/back/pay/underline/modify`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 删除线下支付银行卡账号信息
  deleteDBSiteOfflineBankAccountById(id) {
    const url = `/api/back/pay/underline/delete?id=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 获取所有在线支付信息
  getDBSiteOnlinePayInfo() {
    const url = `/api/back/pay/online/get/all`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 更新在线支付配置
  updateDBSiteOnlinePayInfo(data) {
    const url = `/api/back/pay/online/save`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 更新网银配置
  postInternetBanking(data) {
    const url = `/api/db/merchant/modify`
    return axios.post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data;charset=UTF-8'
      }
    }).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取分页部门信息
  getDBDepartment(page) {
    const url = `/api/department/page?currentPage=${page}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取所有部门信息
  getDBAllDepartment() {
    const url = `/api/department/all`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB添加部门
  postDBAddDepartment(name) {
    const url = `/api/department/save`
    const data = {
      name
    }
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB根据ID获取部门信息
  getDBDepartmentById(id) {
    const url = `/api/department/get?id=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB修改部门名称
  postDBUpdateDepartment(id, name, authorityIds) {
    const url = `/api/department/modify`
    const data = {
      id,
      name,
      authorityIds
    }
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB启用部门
  getDBUpDepartment(id) {
    const url = `/api/department/up?id=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB停用部门
  getDBDownDepartment(id) {
    const url = `/api/department/down?id=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB删除部门
  getDBDeleteDepartment(id) {
    const url = `/api/department/delete?id=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取权限列表
  getDBAuthority() {
    const url = `/api/authority/all`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取员工列表
  getDBEmployee(page) {
    const url = `/api/employee/all?currentPage=${page}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB添加员工
  postDBEmployee(data, surePassword, departmentId, contact, email, position, note, authorityIds) {
    const url = `/api/db/add`
    const datas = {
      data,
      surePassword,
      departmentId,
      contact,
      email,
      position,
      note,
      authorityIds
    }
    return axios.post(url, datas).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB根据id获取当前员工数据
  getDBEmployeeById(id) {
    const url = `/api/employee/info?id=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB修改员工权限
  postDBEmployeeAuth(data) {
    const url = `/api/employee/modify/auth`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB修改员工
  postDBUpdateEmployee(data) {
    const url = `/api/employee/modify/info`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB启用员工账号
  getDBEmployeeUp(id) {
    const url = `/api/employee/status/up?id=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB停用员工账号
  getDBEmployeeDown(id) {
    const url = `/api/employee/status/down?id=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB删除员工账号
  getDBEmployeeDelete(id) {
    const url = `/api/employee/delete?id=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB修改员工密码
  postDBUpdatePossword(id, password) {
    const url = `/api/employee/modify/pwd`
    const data = {
      id,
      password
    }
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default DBSiteSet
